module.exports = __webpack_public_path__ + "img/experts_matching.cdf6af9b.png";